import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "visit-pagination text-center" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "col-12 pagination-text" }
const _hoisted_5 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-link nav-arrows me-4",
      disabled: _ctx.props.page_start == 0,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.previousPage(-10)))
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("i", { class: "fas fa-angle-left" }, null, -1)
    ]), 8, _hoisted_2),
    _createElementVNode("span", null, _toDisplayString(_ctx.page_start + 1) + " - " + _toDisplayString(_ctx.page_end), 1),
    _createElementVNode("button", {
      class: "btn btn-link nav-arrows ms-4",
      disabled: _ctx.props.page_end >= _ctx.props.total,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextPage(10)))
    }, _cache[3] || (_cache[3] = [
      _createElementVNode("i", { class: "fas fa-angle-right" }, null, -1)
    ]), 8, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("i", _hoisted_5, "Total of " + _toDisplayString(_ctx.props.total) + " " + _toDisplayString(_ctx.props.label), 1)
    ])
  ]))
}